import React, { FC } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { INote, NoteType } from "../../types";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    color: "#231F20",
    fontWeight: "bold",
  },
  text: {
    marginTop: 8,
    fontSize: 14,
    color: "#192130",
    wordBreak: "break-word",
  },
  date: {
    fontSize: 14,
    color: "#858997",
    textAlign: "right",
    marginTop: 8,
  },
}));

interface INoteProps {
  note: INote;
}

const noteTitles = {
  [NoteType.AcademicDeactivation]: "Academic deactivation",
  [NoteType.ProgramDeactivation]: "Program deactivation",
  [NoteType.IntakeDeactivation]: "Intake deactivation",
  [NoteType.BranchDeactivation]: "Branch deactivation",
  [NoteType.ApplicationRejection]: "Application rejection reason",
  [NoteType.ApplicationCancellationByStudent]:
    "Application cancellation reason",
};

export const NoteContent: FC<INoteProps> = ({ note: { text, date, type } }) => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.title}>{noteTitles[type]}</Typography>
      <Typography className={classes.text}>{text}</Typography>
      {date && <Typography className={classes.date}>{date}</Typography>}
    </>
  );
};
